import React, { useEffect, useRef, useState } from "react";

import { useSelector, useDispatch } from 'react-redux';

import { Box } from '@mui/material'

import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import 'swiper/css/virtual';
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import "swiper/css/effect-cube";
import "swiper/css/pagination";
import SwiperCore, { FreeMode, Navigation, Thumbs, Virtual } from "swiper";

import { ArrowBack, ArrowForward } from "@/src/components/Icon/Arrow"
import OrkaTwoMV from '@/src/components/Product/OrkaTwo/3d/OrkaTwoMV'
import MuiImage from '@/src/components/MuiImage'
import imgData from './data/imgs'

import { command, selector } from './redux/store'

import style from '@/pages/scss/OrkaTwo.module.scss'

const BannerImg = function({source = [], index = 0} = props) {
    const dispatch = useDispatch();
    const clickHandler = function(next = true) {
        const value = next ? index + 1 : index - 1
        if (value < source.length && value >= 0) {
            dispatch(command.actionSetProductImgIndex(value))
        }
    }
    return (
    <Box sx={{width: {xs: '100vw', sm: 'calc(100vw - 80px * 2)', md: '100%'} }} position='relative'>
        <img src={source[index]} alt="orkaTwo" width="100%" height="100%" style={{display: 'block', boxSizing: 'border-box'}}/>
        <Box position='absolute' bottom={24} right={8} left={8} top={24} display="flex" justifyContent="space-between" alignItems="center">
            <Box mr="16px" onClick={() => clickHandler(false)}><ArrowBack /></Box>
            <Box onClick={() => clickHandler()}><ArrowForward /></Box>
        </Box>
    </Box>
    )
}

// install Virtual module
SwiperCore.use([Virtual, Navigation]);
const BannerImg2 = function ({ source = [], imgs = [], index = 0 } = props) {
    const dispatch = useDispatch()
    const virtualSource = Array(1).fill().map(() => source).flat()
    // const virtualImgs = Array(6).fill().map(() => imgs).flat()
    const virtualImgs = imgs
    const swiperRef = useRef()

    const goto = function(isNext = true) {
        if (isNext) {
            swiperRef.current.swiper.slideNext()
        } else {
            swiperRef.current.swiper.slidePrev()
        }
    }

    const updateSwiper = function(idx) {
        swiperRef.current.swiper.slideToLoop(idx)
    }

    const slideChange = function() {
        const realIndex = swiperRef.current.swiper.realIndex % virtualImgs.length
        dispatch(command.actionSetProductImgIndex(realIndex))
    }

    return (<>
        <Box sx={{ width: { xs: '100vw', sm: 'calc(100vw - 80px * 2)', md: '100%' } }} position='relative'>
            <Swiper
                loop={false}
                ref={swiperRef}
                style={{
                    "--swiper-navigation-color": "#fff",
                    "--swiper-pagination-color": "#fff",
                    width: '100%',
                }}
                spaceBetween={10}
                slidesPerView={1}
                navigation={{
                    prevEl: null,
                    nextEl: null,
                }}
                modules={[FreeMode, Navigation, Thumbs]}
                grabCursor={true}
                pagination={false}
                className={style["img-swiper"]}
                onSlideChange={slideChange}
                noSwiping={true}
                noSwipingSelector='.swiper-no-swiping'
            >
                {virtualSource.map((data, index) => <SwiperSlide className={style['swiper-slide']} key={data} virtualIndex={index}>
                        <MuiImage src={data} alt="orkaTwo" defaultSrc={imgData.miniProductImgs[2]}/>
                        {/* <img src={data} alt='orkaTwo' style={{ width: '100%', height: '100%' }} /> */}
                    </SwiperSlide>)
                    .concat(<SwiperSlide className={style['swiper-slide'] + ' ' + 'swiper-no-swiping'} key={virtualSource.length} virtualIndex={virtualSource.length}>
                        <Box position="relative" width='100%' paddingTop="100%">
                            <Box position="absolute" left="0" top="0" width="100%" height="100%">
                                <OrkaTwoMV />
                            </Box>
                        </Box>
                    </SwiperSlide>)}
                <Box position='absolute' bottom={24} right={8} left={8} top={24} zIndex={1} display="flex" justifyContent="space-between" alignItems="center" sx={{pointerEvents: 'none'}}>
                    <Box className="custom-prev-btn" mr="16px" onClick={() => goto(false)} sx={{pointerEvents: 'all'}}><ArrowBack disable={index < 1}/></Box>
                    <Box className="custom-next-btn" onClick={() => goto()}  sx={{pointerEvents: 'all'}}><ArrowForward disable={index >= source.length}/></Box>
                </Box>
            </Swiper>
        </Box>
        <Box className={style['orkatwo-product-mini-img-box']}>
            <MiniList imgs={imgData.miniProductImgs} index={index} callback={updateSwiper}/>
        </Box>
    </>)
}

const MiniList = function({callback, imgs = [], index = 0} = props) {
    const [first, setFirst] = useState(true)
    const clickHandler = function(clickIndex) {
        callback(clickIndex)
    }
    useEffect(() => {
        const dom = document.querySelector(`#orkatwo-product-img-${index}`)
        if (dom) {
            dom.checked = true
            if (first) {
                setFirst(false)
                return
            }
            dom?.parentElement?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
        }
    }, [index])
    return (
    <Box className={style['orkatwo-product-mini-img-box']}>
        {imgs.map((item, i) => {
            return <Box key={item} onClick={() => clickHandler(i)} sx={{cursor: 'pointer'}} className={style['orkatwo-product-img']}>
                <input type='radio' style={{display: 'none'}} name='orkatwo-product-img' id={`orkatwo-product-img-${i}`}/>
                {/* <img src={`${item}?w=88&fit=crop&auto=format`} alt="orkaTwo" style={{display: 'block', boxSizing: 'border-box'}}/> */}
                <MuiImage src={`${item}?w=88&fit=crop&auto=format`} alt="orkaTwo" imageProps={{width: '100%', height: '100%'}} boxSX={{'>img': {borderRadius: '8px'}}}/>
                <label htmlFor={`orkatwo-product-img-${i}`} className={style['orkatwo-product-img-label']}/>
            </Box>
        })}
    </Box>
    )
}

const ProductImg = function() {
    const index = useSelector(selector.selectProductImgIndex)
    return (
    <Box className={style['product-img-box']}>
        {/* <BannerImg index={index} source={imgData.productImgs}/>
        <MiniList index={index} imgs={imgData.miniProductImgs}/> */}
        <BannerImg2 index={index} source={imgData.productImgs} imgs={imgData.miniProductImgs}/>
    </Box>
    )
}

export default ProductImg